const PARTNERS = [
  {
    name: "The School of Radiance",
    logo: "https://customer-assets.emergentagent.com/job_luxe-med-spa/artifacts/j9k5a0si_IMG_1341.jpeg",
    href: null,
  },
  {
    name: "Shyft Global Services",
    logo: "https://customer-assets.emergentagent.com/job_luxe-med-spa/artifacts/drhyypyd_IMG_1342.jpeg",
    href: "/integration",
  },
  {
    name: "Health Revival",
    logo: "https://customer-assets.emergentagent.com/job_luxe-med-spa/artifacts/l5ei59a6_IMG_1345.jpeg",
    href: null,
  },
  {
    name: "RehabMart",
    logo: "https://customer-assets.emergentagent.com/job_luxe-med-spa/artifacts/z5f8y2fj_IMG_1344.jpeg",
    href: null,
  },
];

export default function Partners() {
  return (
    <section data-testid="partners-section" className="bg-[#FDFCFA] py-24 lg:py-32 border-t border-[#E5E5E5]">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="flex items-center justify-center gap-4 mb-6">
            <span className="w-10 h-px bg-[#C9A961]" />
            <div className="overline">Our Partners</div>
            <span className="w-10 h-px bg-[#C9A961]" />
          </div>
          <h2 className="font-serif-editorial text-4xl lg:text-6xl leading-tight">
            The house we <em className="italic">keep.</em>
          </h2>
          <p className="mt-6 text-[#5C5C5C] leading-relaxed">
            A curated network of educators, logistics operators, and clinical brands that stand alongside TheraTec — each one raising the ceiling of what a modern wellness practice can be.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {PARTNERS.map((p, i) => {
            const inner = (
              <div
                className="group relative bg-white border border-[#E5E5E5] aspect-[4/3] flex items-center justify-center overflow-hidden transition-all duration-500 hover:border-[#C9A961] hover:shadow-[0_20px_40px_-15px_rgba(0,0,0,0.15)]"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <img
                  src={p.logo}
                  alt={p.name}
                  className="max-w-[75%] max-h-[70%] object-contain transition-all duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: "linear-gradient(120deg, transparent 0%, rgba(201,169,97,0.06) 45%, transparent 55%)", mixBlendMode: "multiply" }} />
                <div className="absolute bottom-0 left-0 w-0 h-px bg-[#C9A961] group-hover:w-full transition-all duration-700 ease-out" />
                <div className="absolute top-3 right-3 overline text-[10px] text-[#A8A096] opacity-0 group-hover:opacity-100 transition-opacity duration-500">{p.name}</div>
              </div>
            );
            return p.href ? (
              <a
                key={p.name}
                href={p.href}
                data-testid={`partner-${p.name.replace(/\s+/g, "-").toLowerCase()}`}
                className="block"
                aria-label={p.name}
              >
                {inner}
              </a>
            ) : (
              <div key={p.name} data-testid={`partner-${p.name.replace(/\s+/g, "-").toLowerCase()}`}>
                {inner}
              </div>
            );
          })}
        </div>

        <div className="mt-16 text-center">
          <p className="overline text-[#A8A096]">Interested in partnering with TheraTec? Reach out via the concierge.</p>
        </div>
      </div>
    </section>
  );
}
